// src/util/fashionphoto_api_util.js
export const fetchFashionPhotos = async () => {
  const res = await fetch("/api/fashionphotos", { credentials: "same-origin" });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};
